<template>
  <SnackBar ref="snackbar" />
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="classificacoes"
      :sort-by="[{ key: 'id', order: 'asc' }]"
      class="elevation-1"
      :search="search"
    >
      <!-- eslint-disable -->
      <!-- <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.descricao }}</td>

          <td> -->
      <!-- <v-tooltip
              text="Desabilitar usuário"
              location="bottom"
              v-if="item.raw.ativo"
            >
              <template v-slot:activator="{ props }">
                <v-icon
                  v-bind="props"
                  size="small"
                  class="me-2"
                  @click="modalDesabilitar(item.raw)"
                >
                  mdi-account-off
                </v-icon>
              </template>
            </v-tooltip> -->
      <!-- <v-tooltip text="Reativar usuário" location="bottom" v-else>
              <template v-slot:activator="{ props }">
                <v-icon
                  v-bind="props"
                  size="small"
                  class="me-2"
                  @click="modalReativar(item.raw)"
                >
                  mdi-account-reactivate
                </v-icon>
              </template>
            </v-tooltip>
            <v-tooltip text="Excluir usuário" location="bottom">
              <template v-slot:activator="{ props }">
                <v-icon
                  v-bind="props"
                  size="small"
                  color="red"
                  @click="modalExcluir(item.raw)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-tooltip> -->
      <!--   </td>-->
      <!-- Outras colunas da tabela -->
      <!--  </tr>
      </template>-->

      <!-- eslint-enable -->
      <template #top>
        <v-toolbar flat>
          <v-btn
            style="background: #f9f8f8; font-size: 18px"
            size="small"
            @click="this.$router.go(-1)"
            icon
          >
            <v-icon color="#004984">mdi-arrow-left</v-icon>
          </v-btn>
          <v-toolbar-title style="font-size: 22px; font-weight: bold"
            >Classificação de Itens</v-toolbar-title
          >
          <v-divider class="mx-4" inset vertical></v-divider>

          <div class="flex">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              outline
              hide-details
              variant="underlined"
              style="width: 40%"
            ></v-text-field>
            <div>
              <v-btn
                color="#004984"
                class="button-config"
                style="color: white"
                @click="cadastrarDialog = true"
              >
                Cadastrar Classificação
                <v-icon right style="margin-left: 5px">mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>

          <!-- Nova classificacao -->
          <v-dialog v-model="cadastrarDialog" max-width="620px">
            <v-card>
              <v-card-title>
                <span class="text-h5">Cadastrar Classificação</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-textarea
                      v-model="editedItem.descricao"
                      label="Descrição*"
                      counter
                      rows="3"
                      no-resize
                      maxlength="155"
                      required
                    ></v-textarea>
                  </v-row>
                </v-container>
                <small>*Campo Obrigatório</small>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red"
                  variant="text"
                  @click="cadastrarDialog = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="blue-darken-1"
                  variant="text"
                  @click="cadastrarClassificacao"
                >
                  Cadastrar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!--Editar classificação-->
          <v-dialog v-model="editarDialog" max-width="620px">
            <v-card>
              <v-card-title>
                <span class="text-h5">Editar Classificação</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.descricao"
                        label="Descrição*"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
                <small>*Campo Obrigatório</small>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" variant="text" @click="editarDialog = false">
                  Cancelar
                </v-btn>
                <v-btn
                  color="blue-darken-1"
                  variant="text"
                  @click="editarClassificação(editedItem)"
                >
                  Salvar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!--Excluir classificação-->
          <v-dialog v-model="excluirDialog" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Excluir classificação</v-card-title>
              <v-card-text>
                <p>
                  Esta classificação só pode ser removida se não tiver nenhum
                  <strong>item de avaliação</strong> associado. Deseja realmente
                  excluir a <strong>classificação {{ this.idItem }}</strong
                  >?
                </p>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" variant="text" @click="closeDelete"
                  >Cancelar</v-btn
                >
                <v-btn
                  color="blue-darken-1"
                  variant="text"
                  @click="deleteItemConfirm"
                  >Confirmar</v-btn
                >
                <!-- <v-spacer></v-spacer> -->
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Ver usuário
          <v-dialog v-model="dialogView" max-width="850px">
            <v-card>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="8">
                      <v-label>Nome</v-label>
                      <p>{{ editedItem.name }}</p>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog> -->
        </v-toolbar>
      </template>
      <!-- eslint-disable -->
      <template v-slot:item.actions="{ item }">
        <v-tooltip text="Editar classificação" location="bottom">
          <template #activator="{ props }">
            <v-icon
              v-bind="props"
              size="small"
              class="me-2"
              @click="editItem(item.raw)"
            >
              mdi-pencil
            </v-icon>
          </template>
        </v-tooltip>
        <v-tooltip text="Excluir classificação" location="bottom">
          <template #activator="{ props }">
            <v-icon
              v-bind="props"
              size="small"
              color="red"
              @click="deleteItem(item.raw)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-tooltip>
      </template>
      <!-- eslint-enable -->
      <template #no-data>
        <div class="text-center py-6">
          <span> Sem classificações a listar </span>
        </div>
      </template>
      <!-- <template v-slot:bottom>
        <div class="text-center pt-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>
      </template> -->
    </v-data-table>
  </v-container>
</template>

<script>
import axios from 'axios';
import { VDataTable } from 'vuetify/labs/VDataTable';

import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    VDataTable,
    SnackBar,
  },
  data: () => ({
    descricaoClass: '',
    idItem: 0,
    dialogView: false,
    cadastrarDialog: false,
    editarDialog: false,
    excluirDialog: false,
    headers: [
      {
        title: 'ID',
        align: 'start',
        key: 'id',
      },
      {
        title: 'Descrição',
        align: 'start',
        key: 'descricao',
      },
      { title: 'Ações', key: 'actions', sortable: false },
    ],
    classificacoes: [],
    editedIndex: -1,
    editedItem: {
      id: 1,
      descricao: '',
    },
    defaultItem: {
      id: 1,
      descricao: '',
    },
    search: '',
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? 'Cadastrar Classificação'
        : 'Editar Classificação';
    },
  },

  watch: {
    cadastrarDialog(val) {
      val || this.close();
    },
    editarDialog(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.fetchClassificacao();
  },

  methods: {
    /* eslint-disable */
    /**
     * Busca usuários na API e atualiza a lista de usuários com as informações recebidas.
     * @function
     * @name fetchClassificacao
     * @returns {void}
     * @throws {Error} Se ocorrer um erro na chamada da API.
     */
    /* eslint-enable */

    fetchClassificacao() {
      axios
        .get(API_URL + '/avaliacoes/listar/classificacao', {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          response.data.forEach((element) => {
            this.classificacoes.push({
              id: element.id_classificacao,
              descricao: element.descricao,
            });
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },

    cadastrarClassificacao() {
      const data = {
        descricao: this.editedItem.descricao,
      };

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${store.state.token}`,
        },
      };
      if (this.editedItem.descricao != '') {
        axios
          .post(API_URL + '/avaliacoes/cadastrar/classificacao', data, config)
          .then((response) => {
            console.log(response.data);
            this.$refs.snackbar.showSuccessSnackbar(
              'Concluído!',
              'Classificação cadastrada com sucesso!',
            );
            this.close();
            location.reload();
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        this.$refs.snackbar.showWarningSnackbar(
          'Campos vazios!',
          'Por favor, preencha todos os campos obrigatórios!',
        );
      }
    },

    editarClassificação(item) {
      const data = {
        descricao: item.descricao,
      };

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${store.state.token}`,
        },
      };
      if (item.descricao != '') {
        axios
          .put(
            API_URL + `/avaliacoes/atualizar/classificacao/${item.id}`,
            data,
            config,
          )
          .then(() => {
            this.$refs.snackbar.showSuccessSnackbar(
              'Concluído!',
              'Classificação editada com sucesso!',
            );

            location.reload();
          })
          .catch((error) => {
            console.error(error);
            console.log(item.descricao);
            this.$refs.snackbar.showErrorSnackbar(
              'Uhm! Por algum motivo não conseguimos editar a classificação',
            );
          });
      } else {
        this.$refs.snackbar.showWarningSnackbar(
          'Campos vazios!',
          'Por favor, preencha todos os campos obrigatórios!',
        );
      }
    },
    /**
     * Mostra o item selecionado em um dialog
     *
     * @param {Object} item - O item selecionado
     * @returns {void}
     */
    showItem(item) {
      this.editedIndex = this.classificacoes.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogView = true;
    },

    editItem(item) {
      this.editedIndex = this.classificacoes.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editarDialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.classificacoes.indexOf(item);
      // this.editedItem = Object.assign({}, item);
      // chamar rota de excluir classificação aqui
      this.idItem = item.id;
      this.excluirDialog = true;
    },

    deleteItemConfirm() {
      axios
        .delete(API_URL + `/avaliacoes/classificacao/deletar/${this.idItem}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then(() => {
          this.classificacoes.splice(this.editedIndex, 1);
          this.closeDelete();
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            'Classificação excluída com sucesso!',
          );
        })
        .catch((error) => {
          this.$refs.snackbar.showErrorSnackbar(
            'Erro!',
            error.response.data.error,
          );
        });
    },

    close() {
      this.cadastrarDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.excluirDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    // save() {
    //   if (this.editedIndex > -1) {
    //     Object.assign(this.classificacoes[this.countID], this.editedItem);
    //   } else {
    //     const data = {
    //       descricao: this.editedItem.descricao,
    //     };

    //     const config = {
    //       headers: {
    //         'Content-Type': 'application/json',
    //         Authorization: `Bearer ${store.state.token}`,
    //       },
    //     };

    //     axios
    //       .post(API_URL + '/avaliacoes/cadastrar/classificacao', data, config)
    //       .then((response) => {
    //         console.log(response.data);
    //         this.classificacoes.push(this.editedItem);
    //         this.$refs.snackbar.showSuccessSnackbar(
    //           'Concluído!',
    //           'Classificação cadastrada com sucesso!'
    //         );
    //       })
    //       .catch((error) => {
    //         console.error(error);
    //       });
    //   }
    //   this.close();
    // },

    modalExcluir(item) {
      console.log(item.idUsuario);
      this.idUsuario = item.idUsuario;
      this.nomeUsuario = item.name;
      this.showConfirmationModalExcluir = true;
    },
    modalReativar(item) {
      console.log(item.idUsuario);
      this.idUsuario = item.idUsuario;
      this.nomeUsuario = item.name;
      this.showConfirmationModalReativar = true;
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
  width: 50%;
  align-items: center;
}
.flex-wrap {
  flex-wrap: wrap;
}
.d-flex {
  display: flex;
  padding: 0;
}
.equipe-item {
  width: 98%;
  padding: 10px;
  margin: 10px 5px;
}
.button-config {
  background-color: #004984;
  text-transform: capitalize;
  margin-right: 40px;
  margin-left: 20px;
}
</style>
